import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navigation from '../../components/Navigation';
import { ServiceType } from '../../types/types';

interface ServiceOption {
  id: ServiceType;
  name: string;
  description: string;
}

export const colors = [
  { bg: 'bg-red-500', hover: 'hover:bg-red-600', selected: 'bg-red-600', text: 'text-white', outline: 'outline-red-500' },
  { bg: 'bg-blue-500', hover: 'hover:bg-blue-600', selected: 'bg-blue-600', text: 'text-white', outline: 'outline-blue-500' },
  { bg: 'bg-green-500', hover: 'hover:bg-green-600', selected: 'bg-green-600', text: 'text-white', outline: 'outline-green-500' },
  { bg: 'bg-yellow-500', hover: 'hover:bg-yellow-600', selected: 'bg-yellow-600', text: 'text-white', outline: 'outline-yellow-500' },
  { bg: 'bg-purple-500', hover: 'hover:bg-purple-600', selected: 'bg-purple-600', text: 'text-white', outline: 'outline-purple-500' },
  { bg: 'bg-pink-500', hover: 'hover:bg-pink-600', selected: 'bg-pink-600', text: 'text-white', outline: 'outline-pink-500' },
  { bg: 'bg-indigo-500', hover: 'hover:bg-indigo-600', selected: 'bg-indigo-600', text: 'text-white', outline: 'outline-indigo-500' },
  { bg: 'bg-orange-500', hover: 'hover:bg-orange-600', selected: 'bg-orange-600', text: 'text-white', outline: 'outline-orange-500' },
];

const serviceOptions: ServiceOption[] = [
  {
    id: 'gokart',
    name: 'Gokart',
    description: 'Élvezd a száguldás élményét gokartjainkkal'
  },
  {
    id: 'vr',
    name: 'VR Élmény',
    description: 'Merülj el a virtuális valóság világában'
  },
  {
    id: 'simulator',
    name: 'Szimulátor',
    description: 'Próbáld ki versenyszimulátorunkat'
  },
  {
    id: 'playhouse',
    name: 'Játszóház',
    description: 'Szórakozz játszóházunkban'
  }
];

export default function ChooseBooking() {
  const [selectedService, setSelectedService] = useState<ServiceType | ''>('');
  const navigate = useNavigate();

  const handleServiceChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const service = event.target.value as ServiceType;
    setSelectedService(service);
  };

  const handleContinue = () => {
    if (selectedService) {
      // console.log(selectedService);
      // Itt majd átirányítjuk a felhasználót a megfelelő foglalási oldalra
      navigate(`${selectedService}`);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100">
      <Navigation showPublicBooking={true} />
      <div className="max-w-2xl mx-auto p-6">
        <h1 className="text-3xl font-bold text-gray-900 mb-8 text-center">
          Válassz szolgáltatást
        </h1>

        <div className="bg-white rounded-lg shadow-md p-6">
          <div className="mb-6">
            <label
              htmlFor="service-select"
              className="block text-sm font-medium text-gray-700 mb-2"
            >
              Milyen szolgáltatást szeretnél foglalni?
            </label>

            <select
              id="service-select"
              value={selectedService}
              onChange={handleServiceChange}
              className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
            >
              <option value="">Válassz szolgáltatást...</option>
              {serviceOptions.map((service) => (
                <option key={service.id} value={service.id}>
                  {service.name}
                </option>
              ))}
            </select>
          </div>

          {selectedService && (
            <div className="mb-6">
              <div className="bg-gray-50 rounded-md p-4">
                <p className="text-gray-600">
                  {serviceOptions.find(s => s.id === selectedService)?.description}
                </p>
              </div>
            </div>
          )}

          <div className="flex justify-end">
            <button
              onClick={handleContinue}
              disabled={!selectedService}
              className={`px-6 py-2 rounded-md text-white ${selectedService
                ? 'bg-blue-600 hover:bg-blue-700'
                : 'bg-gray-400 cursor-not-allowed'
                }`}
            >
              Tovább
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
